import type { PartnerFlow, PartnerSearchParams } from "./types";

/**
 * Build the input for getTermsStatus based on flow type.
 */
export function buildTermsStatusInput(flow: PartnerFlow) {
	if (flow.type === "referralApproval") {
		return {
			type: "referralApproval" as const,
			linkId: flow.linkId,
			token: flow.token,
		};
	}
	if (flow.type === "stripeConnect") {
		return { type: "stripeConnect" as const, token: flow.token };
	}
	return null;
}

export function determineFlow(search: PartnerSearchParams): PartnerFlow {
	if (search.linkId && search.token) {
		return {
			type: "referralApproval",
			linkId: search.linkId,
			token: search.token,
		};
	}
	if (search.token && !search.linkId) {
		return { type: "stripeConnect", token: search.token };
	}
	return { type: "none" };
}
